import type { FC, ReactNode } from 'react'
import type { TagRef } from '@/types'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { TAG_KINDS, tagHref } from '@/lib/kinds'

interface TagChipProps {
    tag: TagRef
    count?: number
    size?: 'sm' | 'md'
    active?: boolean
    className?: string
}

const TagChip: FC<TagChipProps> = ({ tag, count, size = 'sm', active = false, className }): ReactNode => {
    const tone = TAG_KINDS[tag.kind]?.tone ?? 'bg-brand-stone'

    return (
        <Link
            href={tagHref(tag.kind, tag.slug)}
            className={cn(
                'relative z-10 inline-flex max-w-full items-center gap-1.5 rounded-full border-2 border-foreground font-semibold transition-colors hover:bg-primary',
                active ? 'bg-primary' : 'bg-card',
                size === 'sm' ? 'px-2.5 py-0.5 text-xs' : 'px-3 py-1 text-sm',
                className
            )}
        >
            <span className={cn('size-2 shrink-0 rounded-full border border-foreground', tone)} aria-hidden='true' />

            <span className='truncate' data-mdlfy-cms={`tags:${tag.id}:name`}>
                {tag.name}
            </span>

            {count !== undefined && (
                <span className='font-mono text-[10px] font-bold text-muted-foreground'>
                    {count}
                </span>
            )}
        </Link>
    )
}

export default TagChip
